import React, { memo } from "react"
import { Container, Card, CardBody, Row, Col } from "reactstrap"
import { useSelector } from "react-redux"
const Absent = attendType => {
  const studData2 = useSelector(state => state.TransportReducer)
  const defaultUrl = "https://commonfiles.prisms.in/commonfiles/avatar.jpg"
  return (
    <div
      style={{
        height: "100%",
        backgroundColor: "#211689",
        overflowY: "scroll",
        scrollBehavior: "smooth",
      }}
    >
      <style>
        {`
          ::-webkit-scrollbar {
            display: none;
          }
          scrollbar-width: none;
          -ms-overflow-style: none;
        `}
      </style>

      <Container
        fluid
        className="p-0"
        style={{ backgroundColor: "#211689", height: "100%" }}
      >
        {studData2.data.data &&
          studData2.data.data.length > 0 &&
          studData2.data.data
            .filter(item => item.attend === 0)
            .map((item, idx) => (
              <Card
                key={idx}
                className="m-2 p-0"
                style={{ border: "2px solid red", borderRadius: "5px" }}
              >
                <CardBody className="p-2">
                  <Row className="align-items-center">
                    <Col xs="auto">
                      <img
                        src={item.avatar ? item.avatar : defaultUrl}
                        alt="avatar"
                        width={70}
                        height={70}
                      />
                    </Col>
                    <Col>
                      <h6 className="mb-1 text-dark" style={{ fontSize: 12 }}>
                        {item.name}
                      </h6>
                      <p
                        className="mb-1"
                        style={{ fontSize: 13, color: "#111" }}
                      >
                        {item.div_name}
                      </p>
                      <p
                        className="mb-1"
                        style={{ fontSize: 13, color: "#111" }}
                      >
                        {item.pickup_route_name}
                      </p>
                      <p className="mb-0" style={{ fontSize: 13 }}>
                        {attendType.attendType === "pickup"
                          ? "Pick up"
                          : "Drop"}
                        <span style={{ color: "#D91A1A", marginLeft: "10px" }}>
                          {attendType.attendType === "pickup"
                            ? "Not Picked"
                            : attendType.attendType === "drop"
                            ? "Not Dropped"
                            : "NA"}
                        </span>
                      </p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))}
      </Container>
    </div>
  )
}

export default Absent
